/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiSanctionHit } from './ApiSanctionHit';
import {
    ApiSanctionHitFromJSON,
    ApiSanctionHitFromJSONTyped,
    ApiSanctionHitToJSON,
    ApiSanctionHitToJSONTyped,
} from './ApiSanctionHit';

/**
 * 
 * @export
 * @interface SanctionHitsPage
 */
export interface SanctionHitsPage {
    /**
     * 
     * @type {number}
     * @memberof SanctionHitsPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof SanctionHitsPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof SanctionHitsPage
     */
    total: number;
    /**
     * 
     * @type {Array<ApiSanctionHit>}
     * @memberof SanctionHitsPage
     */
    content: Array<ApiSanctionHit>;
}

/**
 * Check if a given object implements the SanctionHitsPage interface.
 */
export function instanceOfSanctionHitsPage(value: object): value is SanctionHitsPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function SanctionHitsPageFromJSON(json: any): SanctionHitsPage {
    return SanctionHitsPageFromJSONTyped(json, false);
}

export function SanctionHitsPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SanctionHitsPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(ApiSanctionHitFromJSON)),
    };
}

export function SanctionHitsPageToJSON(json: any): SanctionHitsPage {
    return SanctionHitsPageToJSONTyped(json, false);
}

export function SanctionHitsPageToJSONTyped(value?: SanctionHitsPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(ApiSanctionHitToJSON)),
    };
}

